 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-img-entry-js","22":"stencil-ion-infinite-scroll_2-ios-entry-js","23":"stencil-ion-infinite-scroll_2-md-entry-js","24":"stencil-ion-input-ios-entry-js","25":"stencil-ion-input-md-entry-js","26":"stencil-ion-loading-ios-entry-js","27":"stencil-ion-loading-md-entry-js","28":"stencil-ion-popover-ios-entry-js","29":"stencil-ion-popover-md-entry-js","30":"stencil-ion-progress-bar-ios-entry-js","31":"stencil-ion-progress-bar-md-entry-js","32":"stencil-ion-radio_2-ios-entry-js","33":"stencil-ion-radio_2-md-entry-js","34":"stencil-ion-reorder_2-ios-entry-js","35":"stencil-ion-reorder_2-md-entry-js","36":"stencil-ion-ripple-effect-entry-js","37":"stencil-ion-spinner-entry-js","38":"stencil-ion-split-pane-ios-entry-js","39":"stencil-ion-split-pane-md-entry-js","40":"stencil-ion-tab-bar_2-ios-entry-js","41":"stencil-ion-tab-bar_2-md-entry-js","42":"stencil-ion-tab_2-entry-js","43":"stencil-ion-text-entry-js","44":"stencil-ion-textarea-ios-entry-js","45":"stencil-ion-textarea-md-entry-js","46":"stencil-ion-toggle-ios-entry-js","47":"stencil-ion-toggle-md-entry-js","48":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"068f439f","1":"1ff2c937","2":"e42beff5","3":"163e8fa3","4":"25b6251d","5":"d1bfaa3a","8":"bb1ab95a","9":"20f21af8","10":"760242e6","11":"e64bb2f6","12":"51a0fe4c","13":"fddb7865","14":"b87c3e00","15":"9826b144","16":"3beeb346","17":"82cb4458","18":"2abea036","19":"5f07b901","20":"0634a421","21":"26285a84","22":"88ad3509","23":"7685963a","24":"6ca033c1","25":"b608f0ea","26":"68c30c7f","27":"c8c3dda5","28":"f40d1b99","29":"e6f04380","30":"41f95994","31":"af578577","32":"d08edf5a","33":"9352ddc2","34":"3d936375","35":"c92be56f","36":"983a48dd","37":"eaac15e7","38":"72119dc2","39":"e7f11acf","40":"bd700126","41":"f4eb7751","42":"7316b3c0","43":"61a37e67","44":"6749efc9","45":"beea73f0","46":"c0afa0fd","47":"2147f294","48":"09933f4d","50":"af9fa925","51":"e78ee9e3","52":"1251ac61","53":"df28b2dd","54":"e4136aeb","55":"9bc6dcf2","56":"6a71ba86","57":"4b603308","58":"e227a64c","59":"055a8fa2","60":"fb8d486f","61":"614f9c08","62":"06318ea6","63":"8bc20823","64":"4de7112a","65":"e7db7db4","66":"2d2ae7e3","67":"3c781cda","68":"685e9a12","69":"7ebe33c1","70":"6ab2d230","71":"6301fe6b","72":"adbfcdb0","73":"c0eeb4dd","74":"162683cf","75":"e72e7292","76":"c2cbe375","77":"1f1be0a2","78":"c5642bd0","79":"a7afe775","80":"7c932aea","81":"828e33ed","82":"997803f5","83":"1af02716","84":"164c8d43","85":"af9a4d1a","86":"24e72fc0","87":"21322f04","88":"f1a412e8","89":"23fff2f5","90":"e178cd8a","91":"420ea721","92":"7c0a2eda","93":"698a7965","94":"54b87a48","95":"393e3638","96":"7ad25421","97":"2963ec11","98":"fbd15bd6","99":"0bfb41ac","100":"205e7399"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpphoto-gallery-capacitor-react"] = this["webpackJsonpphoto-gallery-capacitor-react"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
